import { render } from "./SnowEffect.vue?vue&type=template&id=45521002&scoped=true"
import script from "./SnowEffect.vue?vue&type=script&lang=js"
export * from "./SnowEffect.vue?vue&type=script&lang=js"

import "./SnowEffect.vue?vue&type=style&index=0&id=45521002&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45521002"]])

export default __exports__